import { Box, Typography, Button } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function BackToHome() {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        textAlign: "center",
        mt: 8,
        color: "text.secondary",
      }}
    >
      <Typography variant="body2" sx={{ mb: 2 }}>
        {t("back_home_message", "Back to the Home screen / Browse products.")}
      </Typography>

      <Button variant="contained" color="primary" href="/">
        {t("browse_products", "Browse Products")}
      </Button>
    </Box>
  );
}